import React, { useState } from "react";
import Header from "../Components/Header";
import PageHeader from "../Components/PageHeader";
import Footer from "../Components/Footer";
import { Link } from "react-router-dom";
import PharmacyProfileSidebar from "../Components/PharmacyProfileSidebar";

const PharmacyInfo = () => {
	const specializationOptions = [
		{ value: "pediatrics", label: "Pediatrics" },
		{ value: "neurology", label: "Neurology" },
		{ value: "adnarology", label: "adnarology" },
		{ value: "sharicology", label: "sharicology" },
		{ value: "adnarology1", label: "adnarology1" },
		{ value: "sharicology1", label: "sharicology1" },
	];

	const [selectedSpecializations, setSelectedSpecializations] = useState(
		"Area of Specialization",
	);

	const handleChange = (selectedOptions) => {
		setSelectedSpecializations(selectedOptions);
	};

	return (
		<>
			<Header />
			<PageHeader pagename="Pharmacy Profile" />
			<section className="main-sidebar user-profile">
				<div className="container">
					<div className="row">
						<div className="col-lg-4">
							<PharmacyProfileSidebar />
						</div>
						<div className="col-lg-8">
							<div className="main-profile-content radius-20 p-4">
								<div className="main-headind d-flex align-items-center 	gap-3 mb-3">
									<div class="edit-btn back">
										<Link to="/">
											<div class="nav-anchor">
												<i class="fa-solid fa-arrow-left"></i>
											</div>
										</Link>
									</div>
									<h5 class="main-heading level-6 main-heading-font dark-color mb-0 wow animate__animated animate__zoomIn animate__delay-1s ">
										Personal Info
									</h5>
								</div>
								<form>
									<div className="row">
										<div className="form-group col-lg-12">
											<input
												type="text"
												className="form-control"
												placeholder="Pharmacy A"
											/>
										</div>
										<div className="form-group col-lg-6">
											<input
												type="text"
												className="form-control"
												id="firstName"
												placeholder=" John"
											/>
										</div>
										<div className="form-group col-lg-6">
											<input
												type="text"
												className="form-control"
												id="lastName"
												placeholder=" Doe"
											/>
										</div>
										<div className="form-group col-lg-12">
											<input
												type="email"
												className="form-control"
												id="Email"
												placeholder=" PharmacyA@gmail.com"
											/>
										</div>
										<div className="form-group col-lg-12">
											<input
												type="phone"
												className="form-control"
												id="phone"
												placeholder="+00 123 456 789"
											/>
										</div>
										<div className="form-group col-lg-12">
											<input
												type="text"
												className="form-control"
												placeholder="Lorem Ipsum, Dummy address"
											/>
										</div>
									</div>
									<div className="row">
										<div className="form-group col-lg-3">
											<input
												type="text"
												className="form-control"
												placeholder=" Los Angles"
											/>
										</div>
										<div className="form-group col-lg-3">
											<input
												type="text"
												className="form-control"
												placeholder="CA"
											/>
										</div>
										<div className="form-group col-lg-3">
											<input
												type="text"
												className="form-control"
												placeholder="United States"
											/>
										</div>
										<div className="form-group col-lg-3">
											<input
												type="phone"
												className="form-control"
												placeholder="123456"
											/>
										</div>
									</div>
									<Link
										class="btn wrapper-btn-main mb-5 log-in mt-3 level-7 primary-regular-font text-decoration-none"
										href="/contactus/signin.php"
									>
										<span class="bg-wrapper ">Edit</span>
									</Link>
								</form>
							</div>
						</div>
					</div>
				</div>
			</section>
			<Footer />
		</>
	);
};

export default PharmacyInfo;
